var _rect, _g, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParaswap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#356BEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#4A90E2"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#356BEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.854 28.4132C16.5408 30.7007 15.2487 33.0094 13.9355 35.2969H37.5308C35.921 32.4798 34.3325 29.684 32.7439 26.9093L32.7228 26.8882C30.3929 22.8003 28.063 18.7124 25.712 14.5822C23.0856 19.242 20.4592 23.8381 17.854 28.4132ZM29.1856 26.4857C30.3294 28.4979 31.4943 30.51 32.638 32.5434H18.8071C21.1158 28.4979 23.4033 24.5159 25.7332 20.4069C26.8769 22.4614 28.0418 24.4736 29.1856 26.4857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8278 14.6677H12.1316C13.0212 16.2562 13.9108 17.8024 14.8004 19.3698C15.6899 20.9371 16.5795 22.4833 17.4691 24.0719C18.7823 21.7844 20.0531 19.5392 21.324 17.2941C21.8323 16.4045 22.3407 15.5361 22.8278 14.6677Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParaswap);
export default __webpack_public_path__ + "static/media/paraswap.5670a192caf3b22cd3c1d340666d0462.svg";
export { ForwardRef as ReactComponent };